import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "react-feather";
import toast from "react-hot-toast";
import { useListQuickMenuItemsQuery, useUnpinPageMutation } from "../../features/quickMenu/quickMenuApi";
import { iconComponentFor } from "../../features/quickMenu/resolvePageMeta";

// Quick Access lives in the fixed header (not the Dashboard) so a pinned
// page is reachable from anywhere in the app - direct instruction. A single
// click per chip navigates straight there - a dropdown was tried first and
// explicitly rejected ("drop down is two clicks"), so this stays the same
// always-visible chip row used on the Dashboard, just relocated. Horizontal
// scroll (not wrap) if there isn't room, so it never grows the header's
// fixed single-row height.
const HeaderQuickAccess = () => {
  const navigate = useNavigate();
  const { data: items = [] } = useListQuickMenuItemsQuery();
  const [unpinPage] = useUnpinPageMutation();

  if (items.length === 0) return null;

  const handleUnpin = async (e, quickMenuItemId) => {
    e.stopPropagation();
    try {
      await unpinPage(quickMenuItemId).unwrap();
    } catch (error) {
      toast.error(error?.message || "Could not remove from Quick Menu");
    }
  };

  return (
    <li
      className="nav-item d-none d-lg-flex align-items-center me-2"
      style={{ maxWidth: 380, overflowX: "auto" }}
    >
      <div className="d-flex align-items-center gap-2 flex-nowrap">
        {items.map((item) => {
          const Icon = iconComponentFor(item.pageIcon);
          return (
            <span
              key={item.quickMenuItemId}
              className="quick-access-chip"
              onClick={() => navigate(item.pagePath)}
            >
              <span className="quick-access-chip-icon">
                <Icon size={11} />
              </span>
              {item.pageLabel}
              <X
                size={11}
                className="quick-access-chip-remove"
                onClick={(e) => handleUnpin(e, item.quickMenuItemId)}
              />
            </span>
          );
        })}
      </div>
    </li>
  );
};

export default HeaderQuickAccess;
